import api from '@/configs/GlobalRequestHandler.js';

export default {
  getPaymentProviders: () => {
    return api.getRequest('/payment_provider');
  },
  updatePaymentProvider: (name, body) => {
    return api.putRequestWithBody(`/payment_provider/${name}`, body);
  },
  uploadCertificate: (body) => {
    return api.postRequestWithBody('/upload/certificate/p12', body);
  },
  setDefaultPaymentProvider: (name) => {
    return api.putRequestWithBody(`/payment_provider/default/${name}`, {});
  }
}
